// components/SoundCloudLogin.js
import React from 'react';

const SoundCloudLogin = () => {
    const clientId = process.env.REACT_APP_SOUNDCLOUD_CLIENT_ID;
    const redirectUri = 'http://localhost:3040/soundcloud/callback';
    const state = crypto.randomUUID(); // Optional but good to have

    const generateCodeVerifier = () => {
        const array = new Uint8Array(32);
        window.crypto.getRandomValues(array);
        return btoa(String.fromCharCode(...array))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    const generateCodeChallenge = async (codeVerifier) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const digest = await window.crypto.subtle.digest('SHA-256', data);
        const base64Digest = btoa(String.fromCharCode(...new Uint8Array(digest)));
        return base64Digest
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    const startOAuth = async () => {
        const codeVerifier = generateCodeVerifier();
        const codeChallenge = await generateCodeChallenge(codeVerifier);

        // Save verifier + state in localStorage for later use in callback
        localStorage.setItem('sc_code_verifier', codeVerifier);
        localStorage.setItem('sc_oauth_state', state);

        const authUrl = `https://secure.soundcloud.com/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=S256&state=${state}`;

        window.location.href = authUrl;
    };

    return (
        <div className="text-center mt-5">
            <button className="btn btn-warning" onClick={startOAuth}>
                Connect to SoundCloud
            </button>
        </div>
    );
};

export default SoundCloudLogin;